module.exports = __webpack_public_path__ + "a1d88509b40cb619ea6c164fa12d0504.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-320.webp.png
// module id = 282
// module chunks = 0